import {Editor, Range, Point, Transforms} from 'slate';
import { BLOCK_TABLE_WRAP, BLOCK_TABLE_PRE, BLOCK_TABLE_SUF, BLOCK_TABLE_ROW, BLOCK_TABLE_CELL} from './types';
import { deserializeHTML } from '../../TratoFormat'
import produce from 'immer';
import { toast } from 'components/Shared/Toast'
// import { deserializeHTML } from './utils/'

import { MAX_TABLE_COLS, MAX_TABLE_ROWS } from './TableElement'

function isFloat(n){
  return Number(n) === n && n % 1 !== 0;
}

export const withTable = () => (editor) => {
  const {deleteBackward, deleteForward, insertData } = editor;

  const preventDeleteCell = (operation, pointCallback) => (
    unit
  ) => {
    const { selection } = editor;

    if (selection && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: (n) => n.type === BLOCK_TABLE_CELL,
      });

      if (cell) {
        const [, cellPath] = cell;
        const start = pointCallback(editor, cellPath);

        if (Point.equals(selection.anchor, start)) {
          return;
        }
      }
    }

    operation(unit);
  };

  editor.deleteBackward = preventDeleteCell(deleteBackward, Editor.start);

  editor.deleteForward = preventDeleteCell(deleteForward, Editor.end);

  editor.insertData = (data) => {
    const html = data.getData('text/html');

    if (html?.toLowerCase().includes('<table')) {
      const parseTable = deserializeHTML(html);

      let tableToInsert = parseTable.find(el => el.type === 'table')

      if (!tableToInsert) return;

      console.log({tableToInsert})


      const rowCount = tableToInsert.children.length;
      const columnCount = tableToInsert.children.reduce((max, row) => {
        let total = 0;
        row.children.map(col => {
          total += col.colspan 
        })
        if (total > max) max = total;
        return max;
      }, 0)

      if (isFloat(columnCount)) {
        return toast.error('La tabla no es compatible con el editor');  
      }
 
      tableToInsert = produce(tableToInsert, (draft) => {
          draft.row = Math.min(rowCount, MAX_TABLE_ROWS);
          draft.col = Math.min(columnCount, MAX_TABLE_COLS);
          draft.children = draft.children.filter(el => el.type === BLOCK_TABLE_ROW).filter((el, index) => index < MAX_TABLE_ROWS)

          draft.children.forEach(el => {
            el.children = el.children.filter((el) => el.type === BLOCK_TABLE_CELL).filter((el, index) => index < MAX_TABLE_COLS)
            el.children.forEach(el2 => {
              el2.children.filter(el => el.text === BLOCK_TABLE_CELL)
              const textNodes = el2.children.map(el3 => ({ ...el3, text: (el3?.text ?? '').replace(/↵/ig, '').trim() })).filter(el3 => el3.text.length > 0 || ['variable', 'image'].includes(el3.type)).map(c => ({
                type: 'p',
                children: [c]
              }));
              el2.children = !textNodes.length ? [{ type: 'p', text:''}] : textNodes
              
            })
          })
       
      })
      console.log({tableToInsert2: tableToInsert})

      
      const tableNode = {
        type: BLOCK_TABLE_WRAP,
        children: [
          // {
          //   type: BLOCK_TABLE_PRE,
          //   children: [{  children: [{ text: '' }] }]
          // },
          tableToInsert,
          // {
          //   type: BLOCK_TABLE_SUF,
          //   children: [{ text: '' }]
          // },
        ]
      };

      const at = editor.selection ? [editor.selection.focus.path[0] + 1] : [editor.children.length];

      Transforms.insertNodes(editor, tableNode, {
        at
      })
    } else {
      insertData(data);
    }
  };

  return editor;
};